// import { getURLParam } from './helperFunctions'
{

const storeInfo = document.querySelector('.store_location_info')
const stateInput = document.querySelector('.store_location_state select')
const cityInput = document.querySelector('.store_location_city select')
const addressInput = document.querySelector('.store_location_address select')

/**
 * Get valid localized values based on a meta key and the currently selected options
 * @param {string} meta_key 
 * @returns {array}
 */
function _getValidMetaValues(meta_key){
  let validValues = []
  window.feedbackForm.locations.forEach(location => {
    let valid = false
    
    if(stateInput.value){
      valid = location.meta.state == stateInput.value
    }

    if(cityInput.value){
      valid = location.meta.city == cityInput.value
    }

    if(valid){
      validValues.push(location.meta[meta_key])
    }
  })
  return validValues
}

/**
 * Disables specific select option based on a metakey
 * @param {select element} input
 * @param {string} meta_key 
 * @return void
 */
function _disableInvalidOptions(input, meta_key){
  let validMetaValues = _getValidMetaValues(meta_key)

  // hide all invalid options
  Array.from(input.children).forEach(child => {
    child.style.display = child.value && validMetaValues.indexOf(child.value) == -1 ? 'none' : ''
  })

  // if there is only one value, just use that
  let validInputs = Array.from(input.children).filter(c => c.value && c.style.display != "none")
  if(validInputs.length == 1){
    input.value = validInputs[0].value
    _onAddressChange()
  }
}

// reset city and address when state changes
function _onStateChange(){
  cityInput.value = ""
  addressInput.value = ""
  _onAddressChange()
  _disableInvalidOptions(cityInput, 'city')
  _disableInvalidOptions(addressInput, 'address_one')
}

// reset address when city changes
function _onCityChange(){
  addressInput.value = ""
  _onAddressChange()
  _disableInvalidOptions(addressInput, 'address_one')
}

// on address change, show more info about the store (or hide this section)
function _onAddressChange(){
  const foundStore = _findStoreByMeta()
  if(foundStore){
    storeInfo.innerHTML = `
      <div style="background:#f8f8f8;padding:1rem">
        <p>Email this location: <a href="mailto:${foundStore.meta.email}">${foundStore.meta.email}</a></p>
        <br>
        <p>Call this location: <a href="tel:${foundStore.meta.phone_number}">${_formatPhoneNumber(foundStore.meta.phone_number)}</a></p>
      </div>
    `
  } else {
    storeInfo.innerHTML = ``
  }
}

// find a store based the current input values
function _findStoreByMeta(){
  let found
  window.feedbackForm.locations.forEach(location => {
    if(location.meta.state == stateInput.value && location.meta.city == cityInput.value && location.meta.address_one == addressInput.value){
      found = location
    }
  })
  return found
}

// formats a phone number
function _formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

/**
 * Populate all inputes based on the GET param in the URL
 */
function _populateBasedOnUrl(){
  const storeId = window.coolHelperFunctions.getURLParam('storeid')
  if(storeId){
    window.feedbackForm.locations.forEach(location => {
      if(location.meta.store_id == storeId){
        stateInput.value = location.meta.state
        cityInput.value = location.meta.city
        addressInput.value = location.meta.address_one
        _disableInvalidOptions(cityInput, 'city')
        _disableInvalidOptions(addressInput, 'address_one')
        _onAddressChange()
      }
    })
  }
}

/**
 * Kick it off
 */
function feedbackFormHelper() {
  jQuery(document).on('gform_post_render', (event, form_id, current_page) => {
    if(stateInput && cityInput && addressInput){
      addressInput.addEventListener('change', e => _onAddressChange())
      stateInput.addEventListener('change', e => _onStateChange())
      cityInput.addEventListener('change', e => _onCityChange())
      _onStateChange()
      _populateBasedOnUrl()
    }
  })
}
feedbackFormHelper()
}
